function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 80 69"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M38.79 39.15A54.83 54.83 0 0051 21.2 54.15 54.15 0 0055.24 0H39.49a39.13 39.13 0 01-4.26 17.9 39.78 39.78 0 01-12 14.08L17 36.56 41.15 69H61L38.7 39.15h.09zM0 69h16V0H0v69zm71.48-16a8.17 8.17 0 00-4.71 1.52 8.91 8.91 0 00-3.13 4.05 9.5 9.5 0 00-.47 5.2 9.17 9.17 0 002.33 4.6 8.36 8.36 0 004.35 2.46 8.06 8.06 0 004.9-.52A8.63 8.63 0 0078.58 67 9.38 9.38 0 0080 62c0-1.18-.22-2.35-.65-3.45a9.05 9.05 0 00-1.84-2.92 8.48 8.48 0 00-2.77-1.95 8.09 8.09 0 00-3.26-.68z",
  fill: "#000"
}), /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "a"
}, /*#__PURE__*/React.createElement("path", {
  fill: "#fff",
  d: "M0 0h80v69H0z"
})))));